import { baseBackend } from "../../../../../api/base/baseUrl";

const RATES_CLIENT_CITY_URL = "/api/v2/rates/clients/city";

export async function createClientCityRequest(payload) {
  const response = await baseBackend.post(RATES_CLIENT_CITY_URL, payload);
  return response.data;
}

export async function getClientCityListRequest() {
  const response = await baseBackend.get(RATES_CLIENT_CITY_URL);
  return response.data;
}
